import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchSerialNumber = createAsyncThunk(
  'softwareRenewal/fetchSerialNumber',
  async (serial) => {
    const response = await axios.get(`/software_licenses/${serial}`);
    return response.data;
  });

export const sendSerialNumberRecoveryEmail = createAsyncThunk(
  'softwareRenewal/sendSerialNumberRecoveryEmail',
  async (customer_email, { rejectWithValue }) => {
    try {
      const token = document.getElementsByName('authenticity_token')[0].value;
      const data = {
        customer_email,
        authenticity_token: token,
      };

      const response = await axios.post(
        '/software_licenses/recovery.json',
        data
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 541) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue('An error occurred while sending the recovery email');
    }
  });

export const populateRenewal = createAsyncThunk(
  'softwareRenewal/populateRenewal',
  async ({ expirationDate, serial, reminderId }) => {
    const parameters = {
      expiration_date: expirationDate,
      serial,
    };

    if (reminderId) {
      parameters.reminder_id = reminderId;
    }

    const data = {
      serial,
      parameters,
    };

    const token = document.getElementsByName('authenticity_token')[0].value;
    data.authenticity_token = token;
    const variantId = document.getElementsByName('variant_id')[0].value;
    data.variant_id = variantId;
    const response = await axios.post(`/orders/populate_renewal`, data);
    return response.data;
  }
);

export const checkCartItems = createAsyncThunk(
  'softwareRenewal/checkCartItems',
  async () => {
    const response = await axios.get('/orders/cart.json');
    return response.data;
  }
);